export const INFERENTIAL_STATISTICS = 'INFERENTIAL_STATISTICS';

export const SET_PARAMETERS_INFERENTIAL_STATISTICS = `SET_PARAMETERS_${INFERENTIAL_STATISTICS}`;

export const RESET_PARAMETERS_INFERENTIAL_STATISTICS = `RESET_PARAMETERS_${INFERENTIAL_STATISTICS}`;

export const RESET_INFERENTIAL_STATISTICS = 'RESET_INFERENTIAL_STATISTICS';

export const SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL = 'SET_HAS_NUMERICAL_VARIABLES_EMPTY_CELL';

export const SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL = 'SET_HAS_CATEGORICAL_VARIABLES_EMPTY_CELL';
